export default "__VITE_ASSET__ifHh_Qu7__"